import { orchestrator } from 'satcheljs';
import { onMonthCellDoubleClick } from '../actions/monthCellOnClickActions';
import { lazyOpenCalendarFullCompose } from 'owa-calendar-compose-form-lifecycle';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { updateSelectedDate } from 'owa-calendar-surface';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';

/**
 * Opens the full-compose for creating a new event
 *
 */
orchestrator(onMonthCellDoubleClick, actionMessage => {
    const surfaceStore = getSurfaceStore();

    const datapoint = returnTopExecutingActionDatapoint();
    datapoint.addCustomData({ currentDateRangeType: surfaceStore.dateRangeType });

    updateSelectedDate(actionMessage.date, surfaceStore);

    lazyOpenCalendarFullCompose.importAndExecute({
        fullComposeEntrySource: 'Surface',
        eventUpdates: {
            Start: getDefaultStart(actionMessage.date),
            IsAllDayEvent: false,
        },
    });
});
